import DecideState from "./states";

export default function TransactionsEmptyState({ page }) {
  let data = DecideState(page);

  return (
    <div className="flex flex-col items-center text-center px-4 rounded-lg border bg-card text-card-foreground justify-center py-10 border-dashed">
      <div className="p-8 max-w-100 w-full">
        <div className="flex justify-center mb-6 relative overflow-hidden">
          <div className="w-48 h-48">
            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="200" height="200" rx="12" fill="#F3F4F6" />
              <g className="scrolling-items">
                <rect x="20" y="20" width="160" height="40" rx="8" fill="#E5E7EB" />
                <rect x="30" y="30" width="80" height="20" rx="4" fill="#D1D5DB" />
                <rect x="130" y="30" width="40" height="20" rx="4" fill="#9CA3AF" />
                <rect x="20" y="70" width="160" height="40" rx="8" fill="#E5E7EB" />
                <rect x="30" y="80" width="80" height="20" rx="4" fill="#D1D5DB" />
                <rect x="130" y="80" width="40" height="20" rx="4" fill="#9CA3AF" />
                <rect x="20" y="120" width="160" height="40" rx="8" fill="#E5E7EB" />
                <rect x="30" y="130" width="80" height="20" rx="4" fill="#D1D5DB" />
                <rect x="130" y="130" width="40" height="20" rx="4" fill="#9CA3AF" />
                <rect x="20" y="170" width="160" height="40" rx="8" fill="#E5E7EB" />
                <rect x="30" y="180" width="80" height="20" rx="4" fill="#D1D5DB" />
                <rect x="130" y="180" width="40" height="20" rx="4" fill="#9CA3AF" />
              </g>
              <rect x="0" y="0" width="200" height="200" rx="12" fill="url(#paint0_linear)" fillOpacity="0.1" />
              <defs>
                <linearGradient id="paint0_linear" x1="100" y1="0" x2="100" y2="200" gradientUnits="userSpaceOnUse">
                  <stop stopColor="white" />
                  <stop offset="0.5" stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="white" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
        <h2 className="text-2xl font-bold text-violet-800 mb-2">{data.title}</h2>
        <p className="text-gray-600 mb-8">{data.description}</p>
        {data.link && data.buttonText && (
          <a
            href={data.link}
            target="__blank"
            className="w-full bg-violet-800 hover:bg-violet-700 px-4 mt-4 py-2 w-75 text-center items-center text-sm text-white rounded-lg cursor-pointer"
          >
            {data.buttonText}
          </a>
        )}

      </div>
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(-50%);
          }
        }
        .scrolling-items {
          animation: scroll 10s linear infinite;
        }
      `}</style>
    </div>
  )
}
